module.exports = __webpack_public_path__ + "img/460.332a52dd.jpg";